import './bootstrap';
import { createApp } from 'vue';
import App from './App.vue';

createApp(App).mount('#app');

// No pinch zoom, as in native apps (docs/design/SPEC.md, decision 18). iOS ignores user-scalable=no,
// so its gesture events are cancelled too; double-tap zoom is off via touch-action in app.css.
document.addEventListener('gesturestart', (event) => event.preventDefault());

// PWA: static assets are cached by the service worker (docs/pwa/SPEC.md).
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
}
